<template>
  <div class="collapse-table">
    <div
      class="collapse-header"
      :class="{ 'is-active': isOpen, 'bottom-line': !isOpen }"
      @click="toggle"
    >
      <span class="title">{{ title }}</span>
      <span class="icon">
        <i class="icon-outlined_pull-down"></i>
      </span>
    </div>
    <transition name="collapse">
      <div v-show="isOpen" class="collapse-content">
        <rich-table :data="value">
          <rich-table-column
            v-for="column in columns"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
          ></rich-table-column>
        </rich-table>
      </div>
    </transition>
  </div>
</template>

<script>
import { Table as RichTable } from '@didi/rich-ui'
export default {
  name: 'CollapseTable',
  components: {
    RichTable,
  },
  props: {
    title: {
      type: String,
      default: 'Store logo',
    },
    value: {
      type: Array,
      default: () => [],
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: this.defaultOpen,
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    showImage(index) {
      this.$createImagePreview({
        imgs: this.value,
        initialIndex: index,
      }).show()
    },
  },
}
</script>

<style scoped>
.collapse-table {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

/* header（类似 cell） */
.collapse-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0;
  font-size: 32px;
  cursor: pointer;
}

.bottom-line {
  border-bottom: 1px solid #ebebeb;
}

.title {
  color: #595c66;
  font-size: 28px;
  font-family: 'DiDi Sans Pro';
}

/* icon */
.icon i {
  display: inline-block;
  transition: transform 0.3s;
}

/* 展开时旋转 */
.collapse-header.is-active .icon i {
  transform: rotate(180deg);
}

/* 图片列表（竖排） */
.img-list {
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.img-item {
  flex: 0 0 auto;
  width: clamp(200px, 70vw, 280px);
  height: 280px;
  border-radius: 8px;
  background: #f5f5f5;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 空状态 */
.empty {
  height: 200px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 动画 */
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.25s ease;
}

.collapse-enter,
.collapse-leave-to {
  opacity: 0;
  transform: scaleY(0.95);
}

.empty-text {
  color: #999;
  font-size: 24px;
}
</style>
